import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme, css } from 'styled-components';
import { Container as ContainerBase, createMediaRenderer } from '@one/grid';
import { mediaUp, mediaDown } from '@one/theme-utils';

const DefaultWidthWrapper = styled.div``;

const Container = styled(ContainerBase)`
    display: flex;
    flex-direction: column;
    ${mediaDown('small')`
        width:100%;
    `}
`;

const ContainerAligned = styled(ContainerBase)`
    display: flex;
        ${mediaDown('small')`
        width:100%;
        max-width: 100%;
        
    `}
    height: 100vh !important;
    flex-direction: ${props => props.alignmentStyles}
`;

const WidthOverrideContainer = styled(({ widthOverrides, theme, ...props }) => (
    <Container {...props} fluid />
))`
    ${({ theme: { grid: { breakpoints, containers } = {} } = {} }) => {
        const renderer = createMediaRenderer(breakpoints);
        return css`
            ${renderer(
        containers,
        width => `
                width: ${width};
            `,
    )}
        `;
    }};

    ${({ widthOverrides }) => mediaUp('small')`max-width: ${widthOverrides.small};`};

    ${({ widthOverrides }) => mediaUp('medium')`max-width: ${widthOverrides.medium};`};

    ${({ widthOverrides }) => mediaUp('large')`max-width: ${widthOverrides.large};`};

    ${({ widthOverrides }) => mediaUp('extra-large')`max-width: ${widthOverrides.extraLarge};`};

    ${({ widthOverrides }) => mediaUp('huge')`max-width: ${widthOverrides.huge};`};
`;

const WidthWrapper = ({
    isContentFullWidth = false,
    isSticky = false,
    widthOverrides = {},
    alignment,
    children,
}) => {
    const alignmentStyles = {
        top: 'column',
        bottom: 'column',
        left: 'row',
        right: 'row-reverse',
    };

    if (isSticky && Object.values(widthOverrides).some(x => !!x) && alignment !== 'right' && alignment !== 'left') {
        return (
            <WidthOverrideContainer widthOverrides={widthOverrides}>
                {children}
            </WidthOverrideContainer>
        );
    }

    if (isContentFullWidth) {
        return <DefaultWidthWrapper>{children}</DefaultWidthWrapper>;
    }

    if (alignment === 'left' || alignment === 'right') {
        return <ContainerAligned alignmentStyles={alignmentStyles[alignment]}>{children}</ContainerAligned>;
    }

    return <Container>{children}</Container>;
};

WidthWrapper.propTypes = {
    isContentFullWidth: PropTypes.bool,
    isSticky: PropTypes.bool,
    widthOverrides: PropTypes.object,
    children: PropTypes.node,
    alignment: PropTypes.string,
};

export default withTheme(WidthWrapper);
